export default __webpack_public_path__ + "static/media/overview-categories.033ca46c.webp";